/**
 * Classify the current browser document for customer logout / login return targets.
 * - Product apps (extra subdomain segment, e.g. vmm.customer.example.com) should use this tab's URL,
 *   not a shared ?return_url= from the portal.
 * - Main portal shell (customer portal host at /) should not send another app's return_url; stale
 *   query params must not leak into POST /logout when this tab is only the dashboard.
 */

function singleSegmentPath(pathname) {
  const segment = String(pathname || "").replace(/^\/+|\/+$/g, "");
  if (!segment || segment.includes("/")) return "";
  return segment;
}

function hostnameHostOnly(hostname) {
  return String(hostname || "").toLowerCase().split(":")[0] || "";
}

/** True when hostname looks like a product app (one more label than the usual customer portal host). */
export function isLikelyCustomerProductAppHost(hostname) {
  const h = hostnameHostOnly(hostname);
  if (!h || h === "localhost" || h === "127.0.0.1") return false;
  const parts = h.split(".").filter(Boolean);
  if (h.endsWith(".localhost")) {
    return parts.length >= 3;
  }
  return parts.length >= 4;
}

export function isBareLocalhost(hostname) {
  const h = hostnameHostOnly(hostname);
  return h === "localhost" || h === "127.0.0.1";
}

/**
 * Dashboard / login shell on the customer portal host — not a product subdomain and not /{app} path.
 * Bare localhost is excluded so dev servers on 127.0.0.1:PORT still use the real document URL.
 */
export function isMainCustomerPortalShell({
  hostname,
  pathname,
  isOnboardingRoute = false,
  isAcceptInviteRoute = false,
} = {}) {
  if (isOnboardingRoute || isAcceptInviteRoute) return false;
  if (isLikelyCustomerProductAppHost(hostname)) return false;
  if (isBareLocalhost(hostname)) return false;
  const p = String(pathname || "").replace(/\/+$/, "") || "/";
  if (p === "/logout") return true;
  const seg = singleSegmentPath(pathname);
  if (seg && seg !== "logout") return false;
  return true;
}
